module.exports = __webpack_public_path__ + "img/export.2e25bb70.png";